module.exports = __webpack_public_path__ + "8a8af8c74b91d775bfb3e710fb699000.mp4";